import { useTranslation } from 'react-i18next';
import CategoryDropdown from '@/components/feature/CategoryDropdown';
import CategoryButtonGrid from '@/components/feature/CategoryButtonGrid';

export default function CategoriesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6 text-center">
          {t('categoryTitle')}
        </h2>
        <div className="mb-10">
          <CategoryDropdown />
        </div>
        <CategoryButtonGrid />
      </div>
    </section>
  );
}